var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-tabs", {
    attrs: {
      "default-active-key": _vm.activeKey
    },
    on: {
      change: _vm.tabChange
    }
  }, [_vm.isAuth("home.contactWay") ? _c("a-tab-pane", {
    key: "1",
    attrs: {
      tab: _vm.$t("联系方式")
    }
  }, [_vm.activeKey === "1" ? _c("contactWay") : _vm._e()], 1) : _vm._e(), _vm.isAuth("home.clauseList") ? _c("a-tab-pane", {
    key: "2",
    attrs: {
      tab: _vm.$t("条款文件列表"),
      "force-render": ""
    }
  }, [_vm.activeKey === "2" ? _c("clauseList") : _vm._e()], 1) : _vm._e(), _vm.isAuth("home.serviceContract") || _vm.isAuth("home.privacyPolicy") || _vm.isAuth("home.cookieManage") ? _c("a-tab-pane", {
    key: "3",
    attrs: {
      tab: _vm.$t("底栏设置")
    }
  }, [_c("bottomBarSet")], 1) : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };